
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"17","viewBox":"0 0 19 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.44 3.92a6.157 6.157 0 016.241-1.513.934.934 0 001.196-1.087.933.933 0 00-.628-.69A8.04 8.04 0 003.91 2.816a8.02 8.02 0 00-1.557 8.47.185.185 0 01-.07.224l-1.047.689a.746.746 0 00.26 1.356l3.294.678a.747.747 0 00.881-.582l.683-3.29a.746.746 0 00-1.143-.774l-1 .658a.187.187 0 01-.281-.1 6.17 6.17 0 011.51-6.224zm13.447-.303a.748.748 0 00-.573-.603l-3.295-.747a.755.755 0 00-.901.562l-.751 3.275c-.068.295.05.6.298.775a.755.755 0 00.833.023l1.084-.676a.186.186 0 01.164-.02.19.19 0 01.115.118 6.133 6.133 0 01-1.484 6.225 6.22 6.22 0 01-6.24 1.558.943.943 0 00-.932.194.93.93 0 00.379 1.589 8.104 8.104 0 008.32-2.228 7.99 7.99 0 001.558-8.427.185.185 0 01.075-.224l1.01-.631a.745.745 0 00.34-.763z","fill":"#C3AFA3"}})])
          )
        }
      }
    